import type { Announcement } from '../types';

export const a_2026_09_28: Announcement = {
  id: '2026-09-28-canvas-redaction',
  date: '2026-09-28',
  layout: 'spotlight',
  kicker: 'Mise à jour produit · 28 septembre 2026',
  // « Canvas » volontairement absent du titre et de l'intro : les avocats ne
  // connaissent pas ce nom interne. On décrit ce qu'ils peuvent faire.
  title: "Hector s'améliore : rédigez vos actes directement dans une conversation",
  navLabel: 'Rédiger dans une conversation',
  subtitle: '',
  intro: [
    "Vous pouvez désormais demander à Hector de **rédiger un acte depuis une conversation** : le plan, puis l'acte, s'écrivent à côté de l'échange, sans quitter la plateforme.",
    "Vous relisez, ajustez manuellement ou demandez à Hector d'appliquer vos modifications directement dans le document, puis vous le rangez dans votre dossier ou l'exportez vers Word.",
    "Cette mise à jour rend Hector plus flexible dans l'ensemble de vos échanges avec lui : **retouchez votre plan** ou **modifiez la jurisprudence** retenue directement dans le fil de votre conversation, ou **chargez l'un de vos documents ou de vos modèles** pour le retravailler avec lui.",
  ],
  videoCaption: "Découvrez cette nouvelle façon d'interagir avec Hector dans la vidéo ci-dessous",
  // Embed YouTube — https://youtu.be/LOwasalhCIc
  // Même vidéo que la fiche `canvas-redaction` du centre d'aide
  // (helpArticles.ts) : une seule captation, deux surfaces de lecture.
  video: { provider: 'youtube', id: 'LOwasalhCIc' },
  sections: [],
  footer: {
    text: "La vidéo est aussi disponible dans le centre d'aide.",
    cta: {
      label: "Ouvrir le centre d'aide",
      url: 'https://www.app.hector.legal/aide/canvas-redaction',
    },
  },
};
